import React from 'react';

export const Minus = () => (
    <path d='M23.5,11h-23C0.224,11,0,11.224,0,11.5S0.224,12,0.5,12h23c0.276,0,0.5-0.224,0.5-0.5S23.776,11,23.5,11z' />
);